module.exports = __webpack_public_path__ + "img/kegu.acff64ec.png";